var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.features),function(feature){return _c('product-feature',{key:feature.id,attrs:{"heading":feature.heading,"body":feature.body,"benefit":feature.benefit,"media-image":_vm.mediaImage(feature)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }